import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ChallengeOobDeviceData, OobDeviceInfo, OobNotificationInfo } from './oob-device.model';
import { ChallengeError } from '@backbase/identity-core-ang';
import { Observable } from 'rxjs';
import { CountdownService } from '../../../shared/countdown/countdown.service';

@Component({
  selector: 'bb-transaction-signing-oob-device',
  templateUrl: 'oob-device.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionSigningOobDeviceComponent implements OnInit {
  @Output() acceptError = new EventEmitter<Error>();
  @Output() cancel = new EventEmitter<void>();
  @Output() poll = new EventEmitter<void>();
  @Output() resend = new EventEmitter<void>();

  @Input() error: ChallengeError | undefined;

  @Input() enableResendPushNotification!: boolean;

  @Input()
  set data(value: ChallengeOobDeviceData | undefined) {
    this.challengeData = value;

    if (this.challengeData) {
      this.deviceInfo = this.challengeData.data.deviceInformation;

      this.pushNotificationData = this.challengeData.data.pushNotificationInformation;
      this.setResendTime();
    }

    if (this.deviceInfo) {
      this.icon = this.deviceInfo.vendor === 'Apple' ? 'phone-iphone' : 'phone-android';
    }
  }
  get data() {
    if (!this.challengeData) {
      throw new Error('No challenge data set');
    }
    return this.challengeData;
  }

  get pushData(): OobNotificationInfo {
    if (!this.pushNotificationData) {
      throw new Error('No push notification data set');
    }
    return this.pushNotificationData;
  }

  get pushFailure(): boolean {
    return this.enableResendPushNotification && !this.pushData.sendSuccessful;
  }

  icon = '';
  challengeData: ChallengeOobDeviceData | undefined;
  deviceInfo: OobDeviceInfo | undefined;
  private pushNotificationData: OobNotificationInfo | undefined;
  readonly timeUntilResend$: Observable<number> = this.countdown.remainingTime$;

  ngOnInit(): void {
    this.poll.emit();
  }

  private setResendTime(): void {
    if (this.pushData.nextResendSeconds > 0) {
      this.countdown.start(this.pushData.nextResendSeconds);
    }
  }

  constructor(private countdown: CountdownService) {}
}
